export default __webpack_public_path__ + "./images/tv.ed661e43.png";